import { Panel, TableRow } from "@/components";
import { ContractorDetailsProps } from "./types";
import { NO_VALUE } from "@/constants";

export const ContractorDetailsSummary = ({
  data: { CompanyName, ContractNo, SubContractor, ContractAdministrator },
}: {
  data: ContractorDetailsProps;
}) => {
  return (
    <Panel header="Contract Details">
      <TableRow label="Company" value={CompanyName ?? NO_VALUE} />
      <TableRow label="Contract Number" value={ContractNo ?? NO_VALUE} />
      <TableRow
        label="Contract Administrator"
        value={ContractAdministrator ?? NO_VALUE}
        divided
      />
      <TableRow label="Subcontractor Name" value={SubContractor ?? NO_VALUE} />
    </Panel>
  );
};
